export default "__VITE_ASSET__DjRM28nB__"